import { IconDefinition } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { Box, Link, Text } from '@domain-group/suit-theme'

interface TabButtonProps {
  accentColor?: string,
  backgroundColor?: string,
  icon: IconDefinition,
  onClick: () => void,
  selected: boolean,
  text: string,
}

const TabButton = (props: TabButtonProps) => {
  const {
    accentColor, backgroundColor = 'f8f8f8', icon, onClick, selected, text,
  } = props

  return (
    <Link
      onClick={() => onClick()}
      style={{
        margin: '0 16px 16px 0',
        textDecoration: 'none',
        width: 'fit-content',
      }}
    >
      <Box
        as="a"
        alignItems="center"
        borderBottom="3px solid"
        borderColor={selected ? accentColor : 'transparent'}
        justifyContent="space-between"
        marginRight="medium"
      >
        <Box
          alignItems="center"
          backgroundColor={selected ? accentColor : 'transparent'}
          border={selected ? 'none' : '1px solid'}
          borderRadius={5}
          borderBottomLeftRadius={selected ? 0 : '5px'}
          borderBottomRightRadius={selected ? 0 : '5px'}
          color={selected ? `#${backgroundColor}` : 'bodyFontColor'}
          borderColor={selected ? 'none' : 'bodyFontColor'}
          justifyContent="center"
          width="30px"
          height="30px"
        >
          <FontAwesomeIcon fontSize="small" icon={icon} />
        </Box>

        <Text
          color="bodyFontColor"
          fontWeight={500}
          fontSize="small"
          marginLeft="small"
          style={{ whiteSpace: 'nowrap', paddingRight: '4px' }}
        >
          {text}
        </Text>
      </Box>
    </Link>
  )
}

export default TabButton
